import React from 'react';
import { ContactUs, Grid} from "../components"
import { Navbar, Footer } from "../layouts"




const Contact = () => {

    return (
        <>
        <Navbar/>
        <Grid/> 
        <ContactUs/>
        <Footer/>
        </>

    )
}

export default Contact